import { Box, Card, FormHelperText, Grid, Typography } from "@mui/material"
import { DateTimePickerRequiredControl, ReactHooksFormWrapper, TextAreaControl, TextFieldControl, TextFieldRequiredControl } from "@northpowerdev/np-react-utils"
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import useFetchJson from "../../../data/useFetchJson";
import { RadioGroupRequiredControl } from "../../styled/RadioGroupControl";
import { parseISO } from "date-fns";


const yesNoOptions = [
    {key: 'yes', value: 'Yes', label: 'Yes'},
    {key: 'no',  value: 'No',  label: 'No'},
]

const initialFormState = {
    landOwnerComments: '',          // 'free text'
    landOwnerContacts: '',          // 'free text'
    permissionReceived: null,       // 'Yes' | 'No'
    permissionDate: new Date(),     // date
    permissionFromName: '',         // 'free text'
    permissionFromPhone: '',        // 'free text'
    permissionFromEmail: '',        // 'free text'
}

export default function DlspLandOwnerPermissionForm({landOwners, landOwnerPermission, icpNumber, address, onClose}) {

    const { handleSubmit, control, formState: { errors }, setValue, watch /* reset, getValues, trigger */ } = useForm({defaultValues: initialFormState});
    const watchAllFields = watch()

    const {
        isLoading: landOwnerPermissionSaving,
        load: saveLandOwnerPermission,
        } = useFetchJson('/bff/decommissioned-lines-service/api/decommissioned-lines/update-landowner-permission', {method: 'POST'}) 

    useEffect(() => {
        
        // console.log('DlspLandOwnerPermissionForm useEffect')
        if (landOwnerPermission) {
            setValue('landOwnerComments',         landOwnerPermission.landOwnerComments)
            setValue('landOwnerContacts',         landOwnerPermission.landOwnerContacts)

            setValue('permissionReceived',        landOwnerPermission.permissionReceived)
            // console.log('DlspLandOwnerPermissionForm useEffect landOwnerPermission.permissionDate', landOwnerPermission.permissionDate)
            setValue('permissionDate',            landOwnerPermission.permissionDate ? parseISO(landOwnerPermission.permissionDate) : new Date())
            setValue('permissionFromName',        landOwnerPermission.permissionFromName)
            setValue('permissionFromPhone',       landOwnerPermission.permissionFromPhone)
            setValue('permissionFromEmail',       landOwnerPermission.permissionFromEmail)
        }
    }, [landOwnerPermission, setValue])

    const onSubmit = async (data) => {
        console.log('DlspLandOwnerPermissionForm onSubmit data', data)
        const desktopQAOptions = {
            params: {
                icp: icpNumber,
            },
            body: JSON.stringify(data)
        }

        const theAssessmentResponse = await saveLandOwnerPermission(desktopQAOptions)
        if (theAssessmentResponse !== undefined) {
            //
            // Desktop QA form was saved successfully and status was updated. 
            //
            onClose() // tell parent component we're done
        }
    }

    const updatePermissionFields = (permissionReceived) => {
        // console.log('updatePermissionFields permissionReceived', permissionReceived)
        if (permissionReceived === 'No') {
            setValue('permissionDate',      null)
            setValue('permissionFromName',  '')
            setValue('permissionFromPhone', '')
            setValue('permissionFromEmail', '')
        }
    }

    return (
        <Card sx={{my:2, p:2, bgcolor: 'transparent'}}>
        <ReactHooksFormWrapper
                onSubmit={handleSubmit(onSubmit)}
                control={control}
                errors={errors}
                submitLabel="Save Land Owner Permission"
                isSubmitting={landOwnerPermissionSaving}
                submittingLabel="Saving land owner permission..."
        >

            {/* <DebugBox title="landOwners" stringify>{landOwners}</DebugBox> */}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1">
                        Please obtain permission for Northpower staff to enter the property at {address} and inspect electric service lines for safety.<br />
                    </Typography>
                    {
                        landOwners?.length
                        &&
                        <Typography variant="body1" paragraph>
                            Property owners at this location (via GIS):<br/>
                            {
                                landOwners.map((name, index) => <span key={index}>{name}<br/></span>)
                            }
                        </Typography>
                    }

                </Grid>

                <Grid item xs={12} sm={6}>

                    <Box sx={{mb: 2}}>
                        <TextAreaControl control={control} errors={errors} fieldName={'landOwnerContacts'}
                            fieldLabel="Land Owner Contacts" controlSx={{width: '100%', mt: -2}}
                            minRows={4} maxRows={10}
                        />
                        <FormHelperText sx={{mt: -1}}>Name, phone and email for each contact.</FormHelperText>
                    </Box>

                    <RadioGroupRequiredControl control={control} errors={errors} fieldName={'permissionReceived'}
                        fieldLabel="Land Owner Permission Received" controlSx={{my: 2}} options={yesNoOptions}
                        onChange={(e) => updatePermissionFields(e.target.value)}
                    /> <br />

                    {
                        watchAllFields.permissionReceived === 'Yes'
                        &&
                        <>

                            <Typography variant="body2">
                                Yay, that's great. Please add more details about the permission we received.
                            </Typography>

                            <DateTimePickerRequiredControl
                                control={control}
                                errors={errors}
                                fieldName={'permissionDate'}
                                fieldLabel="When did we get permisison"
                                disableFuture={true}
                                // controlSx={{minWidth: '50%'}}
                            /> <br />

                            <TextFieldRequiredControl
                                control={control}
                                errors={errors}
                                fieldName={'permissionFromName'}
                                fieldLabel="Name of person who gave permisison"
                                controlSx={{minWidth: '60%'}}
                            /> <br />

                            <TextFieldControl
                                control={control}
                                errors={errors}
                                fieldName={'permissionFromPhone'}
                                fieldLabel="Their phone number"
                                controlSx={{minWidth: '40%'}}
                            /> <br />

                            <TextFieldControl
                                control={control}
                                errors={errors}
                                fieldName={'permissionFromEmail'}
                                fieldLabel="Email of person who gave permisison"
                                controlSx={{minWidth: '80%'}}
                            /> <br />

                        </>
                    }
                </Grid>

                <Grid item xs={12} sm={6}>

                    <Box sx={{mb: 2}}>
                        <TextAreaControl control={control} errors={errors} fieldName={'landOwnerComments'}
                            fieldLabel="Land Owner Permission Comments" controlSx={{width: '100%', mt: -2}}
                            minRows={8} maxRows={16}
                        />
                        <FormHelperText sx={{mt: -1}}>Note down who you contacted and how they responded. Please also record the date.</FormHelperText>
                    </Box>

                </Grid>
            </Grid>
        </ReactHooksFormWrapper>
        </Card>
    )
}
